<template>
    <h4 class="sub-sub-sub-header" v-html="$t(content)"></h4>
</template>

<script>
export default {
    name: 'SubSubSubHeader',
    props: {
        content: String,
    },
};
</script>

<style scoped>
.sub-sub-sub-header {
    font-size: 16px;
    font-weight: normal;
    text-decoration: underline;
    margin-bottom: 2px;
    margin-top: 4px;
    scroll-margin-top: 20px;
}
</style>
